import React, { useRef, useState } from "react";
import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import DynamicSimpleTable from "../../../util/DynamicSimpleReactTable";
import SVG from "react-inlinesvg";

import {
    errorMessage,
    formatDate,
    formatStatus,
    formatUsername,
    permissionCssClass,
} from "../../../util/Helpers";
import { Button } from "react-bootstrap";
import cogoToast from "cogo-toast";
import { FilterGroup } from "../../Common/components/FilterGroup";
import ViewSocialUserModal from "../pages/modals/ViewSocialUserModal";
import { ViewIcon } from "../../../util/Icons";
import { Permissions, PermissionType } from "../../../util/Permissions";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { useSelector } from "react-redux";
import SuspendUserModal from "../pages/modals/SuspendUserModal";
import EnableUserModal from "../pages/modals/EnableUserModal";
import DemoteUserModal from "../pages/modals/DemoteUserModal";
import { useDownloadSocialReportMutation } from "../../../../redux/apiSlice";
import { Permission } from "../../Common/layout/Permission";

export const PowerUserTable = ({ userGroup, category }) => {
    const tableRef = useRef();
    const adminUser = useSelector(state => state.auth.user);
    const [downloadSocialReport, { isLoading: isLoadingReport }] = useDownloadSocialReportMutation();

    const downloadReport = (params) => (_) => {
        downloadSocialReport({ ...params, userGroup })
            .unwrap()
            .then((payload) => {
                if (payload.type === "application/json") {
                    const reader = new FileReader();
                    reader.onload = function() {
                        const result = JSON.parse(reader.result);
                        cogoToast.success(result.message || "Social Report Initialized");
                    };
                    reader.readAsText(payload);
                    return;
                }
                const url = window.URL.createObjectURL(new Blob([payload]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `Power_User_Report_${Date.now()}.${params.file_ext}`);
                document.body.appendChild(link);
                link.click();
                cogoToast.success("Social Report Initialized");
            })
            .catch((err) => cogoToast.error(errorMessage(err)));
    };

    const [socialModal, setSocialModal] = useState({
        showViewSocialUserModal: false,
        details: null,
    });

    const [supendSocialModal, setSuspendSocialModal] = useState({
        showSuspendSocialUserModal: false,
        details: null,
    });

    const [enableSocialModal, setEnableSocialModal] = useState({
        showEnableSocialUserModal: false,
        details: null,
    });

    const [demoteSocialModal, setDemoteSocialModal] = useState({
        showDemoteUserModal: false, 
        details: null,
    });

    /* Modal show/hide Toggle */
    const toggleModal = (modal) => (_) => {
        setSocialModal({
            ...socialModal,
            [modal]: !socialModal[modal],
        });
    };
    const toggleSuspendModal = (modal) => (_) => {
        setSuspendSocialModal({
            ...supendSocialModal,
            [modal]: !supendSocialModal[modal],
        });
    };

    const toggleEnableModal = (modal) => (_) => {
        setEnableSocialModal({
            ...enableSocialModal,
            [modal]: !enableSocialModal[modal],
        });
    };

    const toggleDemoteModal = (modal) => (_) => {
        setDemoteSocialModal({
            ...demoteSocialModal,
            [modal]: !demoteSocialModal[modal],
        });
    };

    const viewSocialUser = (details) => {
        setSocialModal({ ...socialModal, showViewSocialUserModal: true, details });
    };

    const suspendSocialUser = (details) => {
        setSuspendSocialModal({ ...supendSocialModal, showSuspendSocialUserModal: true, details });
    };

    const enableSocialUser = (details) => {
        setEnableSocialModal({ ...enableSocialModal, showEnableSocialUserModal: true, details });
    };

    const demoteSocialUser = (details) => {
        setDemoteSocialModal({ ...demoteSocialModal, showDemoteUserModal: true, details });
    };

    /* Action Buttons */
    const socialAction = (row) => {
        return (
            <span style={{ whiteSpace: "nowrap" }}>
                <Button
                    title="View Payment"
                    className="btn btn-icon btn-light btn-hover-primary btn-sm bg-white"
                    onClick={(_) => viewSocialUser(row)}
                >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                        <ViewIcon />
                    </span>
                </Button>
                <Button
                    title="Disable User"
                    className={`btn btn-icon btn-light btn-hover-primary btn-sm mx-3 ${permissionCssClass(adminUser, Permissions.SOCIAL, PermissionType.UPDATE)}`}
                    onClick={(_) => suspendSocialUser(row)}
                    disabled={row.suspensionDurationInDays !== 0}
                >
                    <span className={`svg-icon svg-icon-md svg-icon-danger`}>
                        <SVG
                            title="Disable User"
                            src={toAbsoluteUrl("/media/svg/icons/Code/Error-circle.svg")}
                        />
                    </span>
                </Button>
                <Button
                    title="Enable User"
                    className={`btn btn-icon btn-light btn-hover-primary btn-sm mx-3 ${permissionCssClass(adminUser, Permissions.SOCIAL, PermissionType.UPDATE)}`}
                    onClick={_ => enableSocialUser(row)}
                    disabled={row.suspensionDurationInDays === 0}
                >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                        <SVG
                            title="Enable User"
                            src={toAbsoluteUrl("/media/svg/icons/Navigation/Check.svg")}
                        />
                    </span>
                </Button>
                <Button
                    title="Demote User"
                    className={`btn btn-icon btn-light btn-hover-primary btn-sm mx-3 ${permissionCssClass(
                        adminUser,
                        Permissions.SOCIAL,
                        PermissionType.UPDATE
                    )}`}
                    onClick={(_) => demoteSocialUser(row)}
                    disabled={row.userLevel !== "power"}
                >
                    <span className="svg-icon svg-icon-md svg-icon-warning">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M8 1a.5.5 0 0 0-.5.5v9.793L4.854 7.854a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 1 0-.708-.708L8.5 11.293V1.5A.5.5 0 0 0 8 1z" />
                        </svg>
                    </span>
                </Button>

            </span>
        );
    };

    return (
        <>
            <FilterGroup
                defaultFilters={{
                    endDate: new Date().toISOString().split("T")[0],
                }}
                key={category}
            >
                <FilterGroup.DateRange className={"mb-4"} />
                <div className="d-flex">
                    <div className={"mr-4"}>
                        <FilterGroup.Filter name={"userLevel"} label={"User Level"}>
                            <FilterGroup.Option value={""}>All</FilterGroup.Option>
                            <FilterGroup.Option value={"regular"}>
                                Regular User
                            </FilterGroup.Option>
                            <FilterGroup.Option value={"power"}>
                                Power User
                            </FilterGroup.Option>
                        </FilterGroup.Filter>
                    </div>
                </div>
                <FilterGroup.Content className="mt-5">
                    {({ filters }) => {
                        return (
                            <Card>
                                <CardHeader title={`All Social Users`}>
                                    <CardHeaderToolbar>
                                        <Permission
                                            user={adminUser}
                                            module={Permissions.SOCIAL}
                                            permission={PermissionType.READ}
                                        >
                                            <button
                                                type="button"
                                                className={`btn btn-primary btn-sm`}
                                                disabled={isLoadingReport}
                                                onClick={downloadReport({
                                                    file_ext: "csv",
                                                    userLevel: filters?.userLevel || "power",
                                                    startDate: filters?.startDate || "",
                                                    endDate: filters?.endDate || "",
                                                })}
                                            >
                                                Export CSV
                                            </button>
                                        </Permission>
                                    </CardHeaderToolbar>
                                </CardHeader>
                                <CardBody>
                                    <DynamicSimpleTable
                                        key={`${userGroup}`}
                                        queryParams={
                                            `userGroup=${userGroup}` +
                                            `&userLevel=${filters?.userLevel || "power"}` +
                                            `&limit=${10}` +
                                            `&startDate=${filters?.startDate || ""}` +
                                            `&endDate=${filters?.endDate || ""}`
                                        }
                                        searchBox={false}
                                        source={{ url: `/social/users` }}
                                        columns={[
                                            { title: "Profile ID", key: "profileId" },
                                            {
                                                title: "User",
                                                format: (row) =>
                                                    formatUsername(
                                                        row.userId,
                                                        row.username,
                                                        null,
                                                        null,
                                                        "social"
                                                    ),
                                            },
                                            { title: "Level", key: "userLevel" },
                                            {
                                                title: "Created At",
                                                format: (row) => formatDate(row.createdAt),
                                            },
                                            {
                                                title: "Status",
                                                format: (row) => {
                                                    const today = new Date();
                                                    if (row.suspendedAt) {
                                                        const suspensionEndDate = new Date(row.suspendedAt);
                                                        suspensionEndDate.setDate(suspensionEndDate.getDate() + row.suspensionDurationInDays);

                                                        if (today < suspensionEndDate) {
                                                            return formatStatus("Suspended");
                                                        }
                                                    }

                                                    return formatStatus("Active");
                                                },
                                            },
                                            { title: "", format: socialAction },
                                        ]}
                                        ref={tableRef}
                                        onError={(err) => cogoToast.error(errorMessage(err))}
                                        refreshIcon={true}
                                    />
                                </CardBody>
                            </Card>
                        );
                    }}
                </FilterGroup.Content>
            </FilterGroup>

            {socialModal.showViewSocialUserModal && (
                <ViewSocialUserModal
                    {...socialModal}
                    tableRef={tableRef}
                    onHide={toggleModal("showViewSocialUserModal")}
                />
            )}
            {supendSocialModal.showSuspendSocialUserModal && (
                <SuspendUserModal
                    {...supendSocialModal}
                    tableRef={tableRef}
                    onHide={toggleSuspendModal("showSuspendSocialUserModal")}
                />
            )}

            {enableSocialModal.showEnableSocialUserModal && (
                <EnableUserModal
                    {...enableSocialModal}
                    tableRef={tableRef}
                    onHide={toggleEnableModal("showEnableSocialUserModal")}
                />
            )}

            {demoteSocialModal.showDemoteUserModal && (
                <DemoteUserModal
                    {...demoteSocialModal}
                    tableRef={tableRef}
                    onHide={toggleDemoteModal("showDemoteUserModal")}
                />
            )}

        </>
    );
};
